import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Video.css';
import Plyr from "plyr-react"
import "plyr-react/plyr.css"
import { useState } from 'react';
import { faPlay } from '@fortawesome/free-solid-svg-icons';

const Video = () => {
    const [start, setStart] = useState(false);
    const [controls, setControls] = useState([]);

    const videoSrc = {
        type: 'video',
        title: 'Conheça a Academia',
        sources: [
            {
                src: `${process.env.PUBLIC_URL}/home/video/video001.mp4`,
                type: 'video/mp4',
            },
            {
                src: 'epSkfBBgTDs',
                provider: 'youtube',
            },
        ],
        poster: `${process.env.PUBLIC_URL}/logo_com_texto.svg`,
        previewThumbnails: {
            src: `${process.env.PUBLIC_URL}/logo_com_texto.svg`,
        },
    };

    const startVideo = () => {
        if (!start) {
            setStart(true);
            setControls(['play', 'progress', 'current-time', 'captions', 'mute', 'volume', 'fullscreen'])
        }

    }

    return (
        <>
            <section name='video' id='video'>
                <div class="container py-4">
                    <h2 class="title py-2">Conheça o Nosso Trabalho</h2>
                    <div class="video-container" onClick={startVideo}>
                        <div class="base">
                            <Plyr source={videoSrc}  options={{ controls: controls, autoplay: start }} />
                        </div>
                        <div>
                            <button class={`btn btn-play ${start ? 'hidden' : ''}`} >
                                <FontAwesomeIcon icon={faPlay} />
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


export default Video;
